export class IdUtil {
  // 生成不含分隔符的32位十六进制UUID，速度优先
  static fastSimpleUUID(): string {
    let d = Date.now();
    let uuid = '';
    for (let i = 0; i < 32; i++) {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      uuid += r.toString(16);
    }
    return uuid;
  }
}
